import { Dispatch, SetStateAction, useState, MouseEvent } from "react";
import { ReactComponent as FilterIcon } from '../../../../assets/Icons/adornments/Filter.svg';
import { ReactComponent as CheckIcon } from '../../../../assets/Icons/adornments/Check.svg';
import { Menu, MenuItem } from "@mui/material";

export default function CategoryFilter({
    options,
    setSelectedFilter,
    selectedFilter,
}: {
    options: { value: string, label: string }[],
    setSelectedFilter: Dispatch<SetStateAction<string>>,
    selectedFilter: string,
}) {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleMenuItemClick = (e: MouseEvent<HTMLButtonElement>, value: string) => {
        e.preventDefault();
        setSelectedFilter(value);
        handleClose();
    };
    


    return (
        <div>
            <button onClick={handleClick} className="text-outline hover:text-primary transition-all h-full flex justify-center items-center">
                <div className="w-[14px]"><FilterIcon /></div>
            </button>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
            >
                {options.map((option, i) => (
                    <MenuItem 
                        sx={{
                            fontFamily: 'Montserrat',
                            display: 'flex',
                            justifyContent: 'start',
                            alignItems: 'center',
                            gap: '8px',
                        }}
                        key={i}
                        selected={option.value === selectedFilter}
                        onClick={(e:any) => handleMenuItemClick(e, option.value)}
                    >
                        <div className={`${option.value === selectedFilter ? 'opacity-1' : 'opacity-0'} w-[16px]`}><CheckIcon /></div>
                        {option.label}
                    </MenuItem>
                ))}
            </Menu>
        </div>
    )
}